import { ClinicBoard } from "@board/ClinicBoard";
import { useOpenPatient } from "@shell/navigation";

export const ClinicBoardPage = () => (
  <ClinicBoard onOpenPatient={useOpenPatient()} />
);
